import {MuWidget} from "mu-widget/lib/MuWidget";

export class ProcDataField extends MuWidget {
	afterIndex()
	{
	}
	checkAllPackets(ev: Event, part: string)
	{
		this.ui["packets-" + part].querySelectorAll("[data-packet-is-complete]").forEach(function(el) {
			(el as HTMLInputElement).checked = true;
		});
	}
	switchDetails(ev: Event, part: string)
	{
		this.ui[part].classList.toggle("details-visible");
	}
}
